/**
 * Custom input field styles
 */
import { Autocomplete, TextField, FormControl } from '@mui/material';
import { DateField, DatePicker, TimeField } from '@mui/x-date-pickers';

/**
 * @param {any} props
 * @returns Custom text field UI
 */
export const CustomTextField = ({ label, error, id, name, type, inputProps, value, customStyles, ...props }) => (
  <TextField
    sx={{
      width: '100%',
      '& label.Mui-focused': {
        color: '#212b36',
      },
      '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
          borderColor: '#212b36',
        },
      },

      ...customStyles
    }}
    id={id}
    error={error}
    name={name}
    value={value}
    inputProps={inputProps}
    type={type}
    label={label}
    variant="outlined"
    autoComplete='off'
    {...props}
  />
);

/**
 * @param {any} props
 * @returns Custom Autocomplete field UI
 */
export const CustomAutocomplete = ({
  options,
  size,
  id,
  getOptionLabel,
  renderOption,
  isOptionEqualToValue,
  customStyles,
  readOnly,
  forcePopupIcon,
  error,
  ...props
}) => (
  <Autocomplete
    sx={{
      width: '100%',
      '& label.Mui-focused': {
        color: '#212b36',
      },
      '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
          borderColor: '#212b36',
        },
      },
      ...customStyles,
    }}
    forcePopupIcon={forcePopupIcon}
    readOnly={readOnly}
    error={error}
    size={size}
    options={options}
    id={id}
    getOptionLabel={getOptionLabel}
    renderOption={renderOption}
    isOptionEqualToValue={isOptionEqualToValue}
    renderInput={(params) => <TextField {...params} variant="outlined" autoComplete='off' />}
    {...props}
  />
);

/**
 * @param {any} props
 * @returns Custom Date field UI
 */
export const CustomDateField = ({ label, id, name, ...props }) => (
  <DateField
    sx={{
      width: '100%',
      '& label.Mui-focused': {
        color: '#212b36',
      },
      '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
          borderColor: '#212b36',
        },
      },
    }}
    id={id}
    name={name}
    label={label}
    variant="outlined"
    {...props}
  />
);

/**
 * @param {any} props
 * @returns Custom Date field UI
 */
export const CustomTimeField = ({ label, id, name, ...props }) => (
  <TimeField
    sx={{
      width: '100%',
      '& label.Mui-focused': {
        color: '#212b36',
      },
      '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
          borderColor: '#212b36',
        },
      },
    }}
    id={id}
    name={name}
    label={label}
    variant="outlined"
    {...props}
  />
);

/**
 * @param {any} props
 * @returns Custom Time Picker UI
 */
export const CustomDatePicker = ({ label,error,onChange, minDate, maxDate, readOnly, defaultValue, value, ...props }) => (
  <DatePicker
    sx={{
      width: '100%',
      '& label.Mui-focused': {
        color: '#212b36',
      },
      '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
          borderColor: '#212b36',
        },
      },
    }}
    label={label}
    slotProps={{
      textField: {
        error
      }
    }}
    readOnly={readOnly}
    reduceAnimations
    onChange={onChange}
    defaultValue={defaultValue}
    value={value}
    minDate={minDate}
    maxDate={maxDate}
    format="DD/MM/YYYY"
    {...props}
  />
);

/**
 * @param {any} props
 * @returns Custom Form field UI
 */
export const CustomFormControl = (props) => (
  <FormControl
    fullWidth
    sx={{
      '& label.Mui-focused': {
        color: '#212b36',
      },
      '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
          borderColor: '#212b36',
        },
      },
    }}
    variant="outlined"
    {...props}
  />
);
